import { render, staticRenderFns } from "./orgUrl.vue?vue&type=template&id=7c8711e6&scoped=true"
import script from "./orgUrl.vue?vue&type=script&lang=js"
export * from "./orgUrl.vue?vue&type=script&lang=js"
import style0 from "./orgUrl.vue?vue&type=style&index=0&id=7c8711e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8711e6",
  null
  
)

export default component.exports